import $ from "jquery";

/*
 * Venmo Funding Data Service -
 * Wrapper for venmo funding data calls
 */
function executeCall(method, url, payload) {
    const csrfToken = $("[name='__RequestVerificationToken']").val();

    if (typeof (payload) === "object") {
        payload["__RequestVerificationToken"] = csrfToken;
    }

    const executionPromise = new Promise(
        function (resolve, reject) {
            $.ajax({
                type: method,
                url: url,
                data: payload,
                dataType: 'json',
                contentType: 'application/x-www-form-urlencoded; charset=utf-8',
                success: function (data) {
                    return resolve(data);
                },
                error: function (jqXhr, textStatus, errorThrown) {
                    const data = JSON.parse(jqXhr.responseText);
                    return reject(data);
                }
            });
        }
    );

    return executionPromise;
}

class VenmoFundingDataService {
    constructor() {
    }

    init() {
    }

    // Public Methods
    processFundingToken(fundingToken) {
        return executeCall("POST", "/funding/venmo/process", { fundingToken: fundingToken });
    }
}

const dataService = new VenmoFundingDataService();
export default dataService;